
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"65","height":"63"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#0a294a","stroke-miterlimit":"20","stroke-width":"3","d":"M32.387 2.08v0L56.7 13.827v0l6.005 26.395v0L45.88 61.39v0H18.895v0L2.07 40.222v0l6.004-26.395v0z"}}),_c('path',{attrs:{"fill":"#0a294a","d":"M47.76 26.05s.317 2.577.317 5.153v2.416c0 2.576-.317 5.152-.317 5.152s-.311 2.195-1.267 3.16c-1.21 1.269-2.567 1.275-3.19 1.35-4.454.32-11.145.331-11.145.331s-8.276-.076-10.824-.32c-.708-.133-2.3-.092-3.51-1.36-.955-.966-1.265-3.16-1.265-3.16s-.319-2.577-.319-5.153v-2.416c0-2.576.319-5.152.319-5.152s.31-2.195 1.265-3.16c1.21-1.268 2.567-1.274 3.19-1.349 4.455-.322 11.138-.322 11.138-.322h.014s6.683 0 11.138.322c.622.075 1.98.08 3.19 1.348.955.966 1.266 3.16 1.266 3.16zm-10.287 6.043l-8.602-4.49.001 8.95z"}})])
          )
        }
      }
    